<style>
@import '../../custom/css/aguardando.css';
.aprovarPedidoText {
  padding: 0 30px;
  text-align: center;
}
.alertaTaxa {
  padding: 0 70px;
  text-align: center;
  color: red;
}
</style>

<template>
  <div class="aprovadas" id="inicio">
    <b-modal 
      id="modal-rejeitar"
      title="Rejeitar pedido"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <h5 class="mt-3">Informe o motivo pelo qual está rejeitando esse pedido?</h5>
      <input type="text" class="form-control" v-model="paylodRejeitar.motivo" placeholder="Digite o motivo aqui">
      <button class="btn btn-danger btn-block mt-2 mb-3" @click="sendRejeitarCotacao()">Rejeitar pedido</button>
    </b-modal>
    <b-modal 
      id="modal-aprovar"
      title="Aprovar pedido"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div class="row">
        <span class="mt-3 mb-3 aprovarPedidoText">
        Ao aprovar esse pedido, sua loja estará se comprometendo a entregar os produtos, 
        bem como as devidas quantidades descritas no atual pedido dentro do período 
        informado no envio da cotação. 
      </span>
      <span class="alertaTaxa">
        A não entrega ou o cancelamento poderá acarretar uma multa no valor de 
        {{ taxa_cancelamento_sem_mascara > 99 ? taxa_cancelamento : 'R$ 1,00' }}
      </span>
      <button class="btn btn-success btn-block mt-3 mb-3 m-2" @click="sendAprovarCotacao()">Aprovar pedido</button>
      </div>
    </b-modal>
    <div class="row m-0">
      <div class="col-12 my-4">
        <h1
          class="title font-weight-bold text-uppercase d-flex justify-content-center"
        >
          {{
            cotacoes.length > 0
              ? 'Pedidos aguardando aprovação'
              : 'Sem pedidos aguardando aprovação'
          }}
        </h1>
      </div>
      <div
        class="col-lg-4 col-md-6"
        v-for="(cotacao, index) in cotacoes"
        :key="index"
      >
        <div class="card-cotacao">
          <div class="cc-header d-flex">
            <div class="cc-sub-title m-r-25">
              <img
                class="imagem-archive-cotacao"
                src="@/assets/img/icons/file-archive.png"
                alt="Ícone para representar a cotação"
              />
            </div>
            <div class="cc-sub-title">
              <div>
                Data:
                <div class="cc-sub-result">{{ cotacao.atualizado_em }}</div>
              </div>
              <div>
                Cód:
                <div class="cc-sub-result">{{ cotacao.cot_cotacao_id }}</div>
              </div>
            </div>
          </div>
          <div class="cc-footer">
            <span class="btn-ver-cotacao" @click="verCotacao(cotacao.id)">
              Ver pedido
            </span>
            <div class="row mt-2">
              <div class="col-6">
                <span class="btn-aprovar-cotacao" @click="aprovarCotacao(cotacao)">
                  Aprovar pedido
                </span>
              </div>
              <div class="col-6">
                <span class="btn-rejeitar-cotacao" @click="rejeitarCotacaoLojista(cotacao)">
                  Rejeitar pedido
                </span>
              </div>
            </div>
            <div class="row">
              <span class="aprovarPedido">Aprovar pedido até: 
                {{ cotacao.data_pagamento ? cotacao.data_pagamento : "Sem data agendada"}}
                <i class="fas fa-question-circle question-tool-tips" id="aprovarUp"></i>
                <b-tooltip target="aprovarUp">
                  Essa cotação precisa ser aprovada até {{ cotacao.data_pagamento ? cotacao.data_pagamento : "Sem data agendada"}} ou
                  será cancelada automaticamente.
                </b-tooltip>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import scrollToElement from '../../mixins/scrollToElement';
import makeToast from '../../mixins/makeToast';

export default {
  mixins:[scrollToElement, makeToast],
  name: 'AguardandoAprovacao',
  data() {
    return {
      sendTokenClient: '',
      motivo: '',
      cotacao: null,
      taxa_cancelamento: '',
      taxa_cancelamento_sem_mascara: null,
      paylodRejeitar: {
        'idCotacao': null,
        'id': null,
        'motivo': ''
      }
    }
  },
  computed: {
    ...mapGetters([
      // Mapeamento de getters
    ]),
    ...mapState({
      // Mapeamento de states
      token: (state) => state.token,
      dadosUsuario: (state) => state.dadosUsuario,
      cotacoes: (state) => state.cotacoes,
    }),
  },
  created() {
    this.scrollToElement();
    const self = this;

    if (this.checkIsEmpty(this.dadosUsuario)) {
      this.$router.push({ name: 'area-restrita' });
    }

    this.$store.dispatch('emptyCotacoes').then(() => {
      this.$store.dispatch('startLoader');
      setTimeout(() => {
        self.$store
          .dispatch('showCotacoesUsuarioAguardandoAprovacaoLojista', this.dadosUsuario.id)
          .then(() => {
            setTimeout(() => {
              self.$store.dispatch('endLoader');
            }, 1000);
          })
          .catch(() => {
            setTimeout(() => {
              self.$store
                .dispatch(
                  'showCotacoesUsuarioAguardandoAprovacaoLojista',
                  this.dadosUsuario.id
                )
                .then(() => {
                  setTimeout(() => {
                    self.$store.dispatch('endLoader');
                  }, 1000);
                })
                .catch(() => {
                  self.$store.dispatch('endLoader');
                  self.aviso(
                    'Não foi possível carregar as cotações! Tente novamente em 5 minutos!',
                    'danger'
                  );
                });
            }, 1000);
          });
      }, 1000);
    });
  },
  methods: {
    sendRejeitarCotacao() {
      this.$store
        .dispatch('insertCotacaoRespostaRejeitadaLojista', this.paylodRejeitar)
        .then(() => {
          this.aviso('Cotação foi rejeitada com sucesso!', 'success');
          this.$bvModal.hide('modal-rejeitar');
          this.paylodRejeitar.idCotacao = null
          this.paylodRejeitar.id = null
          this.paylodRejeitar.motivo = ''
          setTimeout(() => {
            this.$router.push({
              name: 'lojista-rejeitadas-pelo-usuario',
            });
          }, 1000);
        });
    },
    rejeitarCotacaoLojista(data) {
      this.paylodRejeitar.idCotacao = data.cot_cotacao_id
      this.paylodRejeitar.id = data.id
      
      this.$bvModal.show('modal-rejeitar');
    },
    sendAprovarCotacao() {
      const values = {
        id: this.cotacao.id,
        idCotacao: this.cotacao.cot_cotacao_id,
      };
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('aprovarCotacaoLojista', values)
        .then(() => {
          this.$bvModal.hide('modal-aprovar');
          this.cotacao = null;
          setTimeout(() => {
            this.$store.dispatch('endLoader');
            this.aviso('Cotação foi aprovada com sucesso!', 'success');
            setTimeout(() => {
              this.$router.push({ name: 'lojista-ganhas' });
            }, 1000);
          }, 1500);
        })
        .catch(() => {
          this.$store.dispatch('endLoader');
          this.aviso(
            'Não foi possível aprovar a cotação! Tente novamente em 5 minutos!',
            'danger'
          );
        });
    },
    aprovarCotacao(data) {
      this.taxa_cancelamento = data.taxa_cancelamento;
      this.taxa_cancelamento_sem_mascara = data.taxa_cancelamento_sem_mascara;
      this.cotacao = data;
      this.$bvModal.show('modal-aprovar');
    },
    aviso(texto, tipo) {
      this.$bvToast.toast(texto, {
        title: 'Aviso',
        variant: tipo,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
    checkIsEmpty(value) {
      if (
        value === '' ||
        value === null ||
        value === 'null' ||
        value === 'undefined'
      ) {
        return true;
      }
      return false;
    },
    verCotacao(value) {
      if (!this.checkIsEmpty(value)) {
        this.$router.push({
          name: 'lojista-cotacao-aguardando-pagamento',
          params: { id: value },
        });
      }
    },
  },
};
</script>
<style scoped>
.btn-aprovar-cotacao {
  cursor: pointer;
  color: rgb(255, 255, 255);
  font-size: 0.75em;
  font-family: 'Roboto', sans-serif;
  text-align: center;
  text-transform: uppercase;
  border-radius: 4px;
  background: #28a745;
  -webkit-box-shadow: 3px 3px 2px rgb(0 0 0 / 10%);
  box-shadow: 3px 3px 2px rgb(0 0 0 / 10%);
  display: inline-block;
  padding: 5px;
  width: 100%;
  height: 100%;
}
.btn-rejeitar-cotacao {
  cursor: pointer;
  color: rgb(255, 255, 255);
  font-size: 0.75em;
  font-family: 'Roboto', sans-serif;
  text-align: center;
  text-transform: uppercase;
  border-radius: 4px;
  background: rgb(233, 10, 10);
  -webkit-box-shadow: 3px 3px 2px rgb(0 0 0 / 10%);
  box-shadow: 3px 3px 2px rgb(0 0 0 / 10%);
  display: inline-block;
  padding: 5px;
  width: 100%;
  height: 100%;
}
.aprovarPedido {
  width: 100%;
  padding: 8px 0 0 0;
  color: rgb(233, 10, 10);
  font-size: 13px;
  text-align: center;
}
</style>
